export const ExperimentationAdmin = () => {
  return <div>Experimentation Admin</div>;
};
